import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12a9 9 0 1 0 -9 9","key":"svg-0"}],["path",{"d":"M12 7v5l1 1","key":"svg-1"}],["path",{"d":"M16 16h6v6h-6l0 -6","key":"svg-2"}]]

const IconClockStop = createReactComponent('outline', 'clock-stop', 'ClockStop', __iconNode);

export default IconClockStop;